import React from "react";

export default function InputField({
  value,
  onChange,
  placeholder,
  type = "text",
}) {
  return (
    <input
      type={type}
      className={`w-full p-2 py-[5px] bg-transparent text-[#242424] text-[14px] font-normal rounded-[4px] border border-[#232633] outline-none shadow-[2px_2px_5px_0_rgba(0,_39,_81,_0.25)_inset] appearance-none  px-2 text-center  ${
        type === "date" ? "cursor-pointer" : ""
      }`}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
    />
  );
}
